import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PalletTransactions_ds_pallet_transactions_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { days?: number, project_id?: number, pallet_class_id?: number, $top?: number, $skip?: number }): Promise<{ result?: { Label?: string, Value?: number }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_pallet_transactions_widget/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      days?: number, project_id?: number, pallet_class_id?: number    }) {
      return false;
    }
}
